/*
 * @Author: your name
 * @Date: 2021-03-05 15:02:46
 * @LastEditTime: 2022-06-22 09:42:29
 * @LastEditors: zhaozhuo
 * @Description: In User Settings Edit
 * @FilePath: \edc-mobile-web\src\assets\js\dictionary.js
 */
// 账户状态
export const accountFlag = [
	{ label: '冻结', value: 0 },
	{ label: '激活', value: 1 }
]
// 小数类型
export const allowDecimalType = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 计算类型
export const calculateType = [
	{ label: '人工录入', value: 0, flag: true },
	{ label: '计算', value: 1, flag: false },
	{ label: '默认值', value: 2, flag: true }
]
// 操作类型
export const calculateItemType = [
	{ label: '变量', value: 1 },
	{ label: '数字', value: 2 },
	{ label: '操作符', value: 3 }
]
// 计算函数
export const calculateFunctionType = [
	{ label: '默认', value: 0, type: 0, baseType: 'CTX' },
	{ label: '岁月计算', value: 1, type: 2, baseType: 'CTX' },
	{ label: '选项数量计算', value: 2, type: 3, baseType: 'CTX' },
	{ label: '选项计算', value: 3, type: 4, baseType: 'SCTX' }
]
// 计算日期类型
export const calculateDateUnitType = [
	{ label: '年', value: 1 },
	{ label: '月', value: 2 },
	{ label: '日', value: 3 },
	{ label: '小时', value: 4 },
	{ label: '分钟', value: 5 },
	{ label: '秒', value: 6 }
]
// 中心状态
export const centerFlag = [
	{ label: '未启用', value: 0, color: '#fc7a58' },
	{ label: '启用', value: 1, color: '#51CF66' }
]
// 条件类型
export const conditionType = [
	{ label: '等于', value: '==', flag: 0 },
	{ label: '不等于', value: '!=', flag: 0 },
	{ label: '小于', value: '<', flag: 2 },
	{ label: '小于等于', value: '<=', flag: 2 },
	{ label: '大于', value: '>', flag: 2 },
	{ label: '大于等于', value: '>=', flag: 2 },
	{ label: '介于', value: '[]', flag: 2 },
	{ label: '包含', value: '{}', flag: 1 },
	{ label: '不包含', value: '{/}', flag: 1 }
]
// 校验状态
export const checkFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 受试者编号创建
export const createFlagType = [
	{ label: '手动生成', value: 0 },
	{ label: '系统生成', value: 1 }
]
// 位置类型
export const directionType = [
	{ label: '横向', value: 0 },
	{ label: '纵向', value: 1 }
]
// 环境基础类型（发布需要用）
export const environmentInitialType = 0
// 环境类型
export const environmentType = [
	{ label: '测试环境', value: 1 },
	{ label: '生产环境', value: 2 }
]
// 到期类型
export const expireType = [
	{ label: '等待录入', value: 1 },
	{ label: '未过期', value: 2 },
	{ label: '已过期', value: 3 },
	{ label: '过期一到两周', value: 4 },
	{ label: '两周内到期', value: 5 },
	{ label: '自定义', value: 6 }
]
// ePRO
export const eproFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 表单状态
export const formStatusFlag = [
	{ label: '未完成', value: 1 },
	{ label: '已完成', value: 2 }
]
// 表单类别
export const formType = [
	{ label: '自定义', value: 0 }
	// {label: '不良事件', value: 1},
	// {label: '合并用药', value: 2},
	// {label: '问卷量表', value: 3},
	// {label: '医疗设备', value: 4},
	// {label: '实验室检查', value: 5},
	// {label: '其他', value: 6}
]
// 招募是否启用
export const isReruitmentFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 添加状态
export const isAddFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 是否展示类型
export const isShowItemNameFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 是否展示类型
export const isShowOptionNameFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 是否关联
export const isTesteeRelateFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 存在epro表单
export const isExistsEproFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 日志类型
export const logType = [
	{ label: '操作日志', value: 1 },
	{ label: '异常日志', value: 2 }
]
// 任务状态说明
export const taskFlag = [
	{ label: '导出中', iconfont: 'iconyunshangchuan', value: 1, color: '#49a4ff' },
	{ label: '导出成功', value: 2, iconfont: 'icondaochuchenggong', color: '#51CF66' },
	{ label: '导出失败', value: 3, iconfont: 'iconshibai', color: '#fc7a58' }
]
// 质疑状态说明
export const queryFlag = [
	{ label: '新增质疑', value: 11, color: '#49a4ff' },
	{ label: '等待我回复', value: 12, color: '#f8bf32' },
	{ label: '等待他人回复', value: 13, color: '#0747b0' },
	{ label: '已关闭质疑', value: 14, color: '#fc7a58' }
]
// 操作类型
export const operateType = [
	{ label: '增加', value: 1 },
	{ label: '删除', value: 2 },
	{ label: '查找', value: 3 },
	{ label: '修改', value: 4 }
]
// 选项集类型
export const optionType = [
	{ label: '文本', value: 1 },
	{ label: '图片', value: 2 }
]
// 方案创建
export const planCreateFlagType = [
	{ label: '顺序', value: 0 },
	{ label: '随机', value: 1 }
]
// 医患关系类型
export const patientRelationType = [
	{ label: '本人', value: 7 },
	{ label: '夫妻', value: 1 },
	{ label: '子女', value: 2 },
	{ label: '父母', value: 3 },
	{ label: '兄弟', value: 4 },
	{ label: '姐妹', value: 5 },
	{ label: '其他', value: 6 }
]
// 是否sdv类型
export const sdvFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// sdv类型
export const sdvType = [
	{ label: '未开始', value: 1, color: '#fc7a58' },
	{ label: '进行中', value: 2, color: '#e6a23c' },
	{ label: '已完成', value: 3, color: '#51CF66' }
]
// 范围核查
export const scopeValidType = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 性别类型
export const genderType = [
	{ label: '男', value: 1 },
	{ label: '女', value: 2 }
]
// 提交状态
export const submitType = [
	{ label: '保存', value: 2 },
	{ label: '提交', value: 3 }
]
// 标题类型
export const titleType = [
	{ label: '一级标题', value: 18 },
	{ label: '二级标题', value: 16 },
	{ label: '三级标题', value: 14 }
]
// 是否只读类型
export const readonlyFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 研究类型
export const researchType = [
	{ label: '干预型', value: 0 },
	{ label: '观察型', value: 1 }
]
// 研究操作状态类型
export const researchOperateStatus = [
	{ label: '正常', value: 0 },
	{ label: '删除', value: 1 },
	{ label: '归档', value: 2 }
]
// 研究状态类型
export const researchStatus = [
	{ label: '设计中', value: 1, color: '#f8bf32' },
	{ label: '已发布', value: 2, color: '#51CF66' }
]
// 重复类型
export const repeatType = [
	{ label: '可重复', value: 1 },
	{ label: '不可重复', value: 0 }
]
// 重复类型
export const repeatFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 是否需要类型
export const requiredFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 是否跳过检查保存
export const skipCheckSaveFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 备注状态
export const remarkFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 招募状态
export const recruitmentFlag = [
	{ label: '未招募', value: 0 },
	{ label: '同意', value: 1, color: '#51CF66' },
	{ label: '拒绝', value: 2, color: '#fc7a58' }
]
// 列类型
export const optionColumnType = [
	{ label: '1', value: 1 },
	{ label: '2', value: 2 },
	{ label: '3', value: 3 },
	{ label: '4', value: 4 },
	{ label: '默认', value: 0 }
]
// 角色类型
export const roleType = [
	{ label: '设计角色', value: 1 },
	{ label: '项目角色', value: 2 }
]
// 计算类型
export const ruleCalculateType = [
	{ label: '数值', value: 1, baseType: ['CTX', 'SCTX'] },
	{ label: '时间', value: 2, baseType: ['CTX'] },
	{ label: '选择', value: 3, baseType: ['CTX'] }
]
// 用户状态
export const userFlag = [
	{ label: '未启用', value: 0, color: '#fc7a58' },
	{ label: '启用', value: 1, color: '#51CF66' }
]
// 用户归属
export const userAscription = [
	{ label: '研究', value: 1 },
	{ label: '中心', value: 2 }
]
// 访视类型
export const visitType = [
	{ label: '计划', value: 1 },
	{ label: '非计划', value: 0 },
	{ label: '通用', value: 2 }
]
// 访视任务完成类型
export const VisitTaskFlag = [
	{ label: '已完成', value: 1 },
	{ label: '未完成', value: 2 }
]
// 访视类型
export const visitStatusType = [
	{ label: '未开始', value: 1, img: require('@/assets/img/button/noStart.png'), isVisitTask: true },
	{ label: '进行中', value: 2, img: require('@/assets/img/button/enter.png'), isVisitTask: true },
	{ label: '已完成', value: 3, img: require('@/assets/img/button/complete.png'), isVisitTask: true },
	{ label: '跳过', value: 4, img: require('@/assets/img/button/jump.png'), isVisitTask: false }
]
// 是否显示类型
export const visibleFlag = [
	{ label: '是', value: 1 },
	{ label: '否', value: 0 }
]
// 计算表示
export const calculateSymbol = {
	power2: '²',
	power3: '³',
	radical: '√￣',
	ln: 'ln',
	deleteBtn: 'DEL',
	clearBtn: 'C'
	// addBtn:'+',
	// addBtn:'-',
	// addBtn:'*',
	// addBtn:'/',
	// addBtn:'(',
	// addBtn:')',
}
// 组参数
export const groupAttribute = {
	groupCode: 'root',
	groupName: '默认组'
}
// 提示
export const trailTip = {
	1: '首次提交数据',
	2: '添加数据',
	3: '修改数据 ',
	4: '添加备注',
	5: '删除备注'
}
// 可以计算组件类型
export const calculateControlList = ['NTX', 'DP', 'TP', 'DTP']
export const formatterObj = {
	year: '年',
	month: '月',
	day: '日',
	hour: '时',
	minute: '分',
	second: '秒'
}
// 用户登录身份
export const identityType = [
	{ label: '受试者', value: 1 },
	{ label: '医生', value: 2 }
]
// 受试者表单页面状态
export const testeeType = [
	{ label: '受试者录入', value: 1 },
	{ label: '添加/编辑受试者', value: 2 }
]
// 搜索组件status
export const searchStatus = [
	{ label: '受试者检索', value: 1 },
	{ label: '招募检索', value: 2 }
]
// 首诊医院
export const firstHospital = [
	{ label: '北京协和医院变态反应科', value: 1 },
	{ label: '其他', value: 2 }
]